import { render } from "./IssueFeedback.vue?vue&type=template&id=5381dbb0&scoped=true"
import script from "./IssueFeedback.vue?vue&type=script&lang=js"
export * from "./IssueFeedback.vue?vue&type=script&lang=js"

import "./IssueFeedback.vue?vue&type=style&index=0&id=5381dbb0&scoped=true&lang=scss"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5381dbb0"]])

export default __exports__